import React from "react";

import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import Card from "./card";

class FullWidthCard extends Card 
{
    render () 
    {
        let data = this.props.data.node;

        return (
            <article className="post-card post-card-full">
                <div className="post-card-wrap">
                    {
                        <Link to={ data.link } className="post-card-wrap-image">
                            {/* load the thumbnail if the image is valid */}
                            {this.isImageValid(data.featuredImage)
                            ? 
                                <GatsbyImage image={ data.featuredImage.node.localFile.childImageSharp.gatsbyImageData } className="lazyload" alt="" />
                            : 
                                null
                            }
                        </Link>
                    }
                    <Link to={ data.link }>
                        <p className="post-card-wrap-title h-large title">{ data.title }</p>
                    </Link>
                </div>
            </article>
        );
    }
}

export default FullWidthCard;